<template>
  <div class="connect">
    <div class="cont">
      <p>{{$t('lang.foot_Phone')}}</p>
      <p>{{$t('lang.foot_Mailbox')}}</p>
      <p>{{$t('lang.foot_Address')}}</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>


<style lang="less" scoped>
.connect {
  position: absolute;
  bottom: 0;
  width: 100%;
  .cont {
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding:30px 10px;
  }
}
</style>
